import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, NgZone, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@shared/services/common';
import { Constants } from '@shared/models/constants';
import { CommonMethods } from '@services/common.method';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { AuthService } from '@services/auth.service';
import { CompanyModel, TextEditorModel } from 'src/app/fs-lte/models/company.model';
import { NotificationsService } from '@shared/services/notification';
import { ImageUploadMode } from 'src/app/fs-lte/enums/img-upload-mode.enum';
import { CompanyService } from "@fs/services/company"
import { ISubscription } from 'rxjs/Subscription';
import { TabOpenService } from '@services/tab-open.service';
import { ActionName } from '@shared/enums/action-name';
import { PrintSettings } from 'src/app/shared/enums/print-settings';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { customJS } from '@fs/services/customjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var google;

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})

export class CompanyComponent implements OnInit {
  //#region Input/Output/ViewChild  
  @Input() tabCounter: number;
  @Input() routeToParent: boolean = false;
  @Output() goToParent = new EventEmitter();
  @Output() resetUnsavedTrigger: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("attachmentDragAndDropImage") attachmentDragAndDropImage: ElementRef;
  @ViewChild("attachmentDeletePreview") attachmentDeletePreview: ElementRef;
  @ViewChild("attachmentUploadImageBtn") attachmentUploadImageBtn: ElementRef;
  @ViewChild("attachImagePreview") attachImagePreview: ElementRef;
  @ViewChild("addresstext") addresstext: ElementRef;
  @ViewChild("attachmentImageFileControl1") attachmentImageFileControl1: ElementRef;  
  //#endregion 

  //#region Variables
  public subTabCounter: number;
  public companyData: CompanyModel;
  public isEditMode = false;
  public phoneMask = Constants.PhoneMask;
  public woWarranty: FormControl = new FormControl("");
  public saWarranty: FormControl = new FormControl("");
  public estWarranty: FormControl = new FormControl("");
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: Constants.DefaultImageExtension,
    maxFileSize: Constants.DefaultFileSize.inbytes
  };
  public allowedextensionsforAttachment: string = '';
  public allowedsizeforAttachment: number = 0;
  public companyInfoForm: FormGroup;
  public states = [];
  public actionName = ActionName;

  private destroyTab: boolean = false;
  private EmailValidator = this.commonMethods.EmailValidator;
  private ZipCodeValidator = this.commonMethods.ZipCodeValidator;
  private componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    neighborhood: 'long_name',
    sublocality_level_1: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    premise: 'long_name',
    postal_code: 'short_name'
  };
  public defaultImage: string = Constants.DefaultImagePaths.ImageLogo;
  public printModalSettings = { show: false, type: 'wo' };
  public statesEx: any;
  public mnemonicData: { name: string, mapCodes: string[] };

  private subscriptions: ISubscription[] = [];
  private readonly ngUnsubscribe = new Subject();
  //#endregion

  //#region Constructor
  constructor(
    private httpCommonService: CommonService,
    private commonMethods: CommonMethods,
    private auth: AuthService,
    private toastr: NotificationsService,
    private tabopen: TabOpenService,
    private httpCompany: CompanyService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private $elementRef: ElementRef,
    private zone: NgZone) {
    this.subTabCounter= this.commonMethods.generateDynamictabCounter();
    this.httpCommonService.GetStates().subscribe(
      response => {
        this.states = response;
      });

    this.tabopen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.SaveInfo();
      }
    });
    this.companyData = new CompanyModel();
    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(this.uploadRestrictions.allowedExtensions);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;
    this.httpCommonService.GetCandianStates().subscribe(
      response => {
        this.statesEx = response;
      });
    this.mnemonicData = this.commonMethods.getMnemonicData();
  }
  //#endregion

  //#region Lifecycle events
  ngOnInit() {
    this.CreateCompanyInfoForm(new CompanyModel());
    this.GetCompanyData();
  }

  ngAfterViewInit() {
    if (this.isEditMode) {
      var hasImg = !CommonMethods.CheckNullOrUndefined(this.companyInfoForm.controls["LogoURL"].value, true);
      if (hasImg)
        this.ChangeImageUploadMode(ImageUploadMode.Edit);
      else
        this.ChangeImageUploadMode(ImageUploadMode.Upload);
    }
    else {
      this.ChangeImageUploadMode(ImageUploadMode.View);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  //#endregion

  //#region Methods
  private GetCompanyData() {
    this.showspinner.showloader(this.viewContainerRef, this.subTabCounter);
    this.httpCommonService.GetIntialData(this.auth.getCompanyId(), "companyinfos").pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
        this.companyData = response;
        this.CreateCompanyInfoForm(this.companyData);
      }, error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error");
      });
  }
  public ShowSettings(type: string)
  {
    this.printModalSettings = { show: true, type };
  }
  public HideSettings()
  {
    this.printModalSettings = { show: false, type: 'wo' };
  }
  public ChangeImageUploadMode(mode: ImageUploadMode) {
    $(this.attachmentDeletePreview.nativeElement).hide();
    $(this.attachmentUploadImageBtn.nativeElement).hide();
    $(this.attachImagePreview.nativeElement).hide();
    $(this.attachmentDragAndDropImage.nativeElement).show();
    switch (mode) {
      case ImageUploadMode.Edit:
        $(this.attachImagePreview.nativeElement).show();
        $(this.attachmentDeletePreview.nativeElement).show();
        $(this.attachmentUploadImageBtn.nativeElement).show();
        $(this.attachmentDragAndDropImage.nativeElement).hide();
        break;
      case ImageUploadMode.Upload:
        $(this.attachImagePreview.nativeElement).hide();
        $(this.attachmentDeletePreview.nativeElement).hide();
        $(this.attachmentUploadImageBtn.nativeElement).hide();
        $(this.attachmentDragAndDropImage.nativeElement).show();
        break;
      case ImageUploadMode.View:
        $(this.attachImagePreview.nativeElement).show();
        $(this.attachmentDeletePreview.nativeElement).hide();
        $(this.attachmentUploadImageBtn.nativeElement).hide();
        $(this.attachmentDragAndDropImage.nativeElement).hide();
        break;
    }
  }

  public EditInfo() {
    this.isEditMode = true;
    var hasImg = !CommonMethods.CheckNullOrUndefined(this.companyInfoForm.controls["LogoURL"].value, true);
    if (hasImg) this.ChangeImageUploadMode(ImageUploadMode.Edit); else this.ChangeImageUploadMode(ImageUploadMode.Upload);
    customJS.resetPage(this.$elementRef.nativeElement);
    this.GetCompanyData();
    setTimeout(() => {
      this.GetPlaceAutoComplete();
    }, 200);
  }

  public SaveInfo() {
    if (this.companyInfoForm.valid) {
      let submitModel = this.GetSubmitModel();

      this.showspinner.showloader(this.viewContainerRef, this.subTabCounter, 0);
      this.httpCompany.EditCompany(submitModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(r => {
        this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
        this.toastr.success(Constants.CustomToastMessages().CompanyUpdateSuccess, "Success!");
        this.companyData = r;
        this.isEditMode = false;
        customJS.resetPage(this.$elementRef.nativeElement);
        this.ChangeImageUploadMode(ImageUploadMode.View);
        this.CreateCompanyInfoForm(r);
        this.markFormsAsPristine();

        if (this.destroyTab) {
          setTimeout(() => {
            this.tabopen.DestroyTab(this.tabCounter)
          }, 100)
        }
        else if (this.routeToParent) {
          setTimeout(() => {
            this.goToParent.emit()
          }, 100)
        }
        this.resetUnsavedTrigger.emit({ isUnsavedTriggered: false });
        //get updated data
        this.GetCompanyData();
      },
        error => {
          this.toastr.showMultiLineError(error.error.Message, "Error");
          this.destroyTab = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
          //show updated data even in case of error to maintain consistency
          this.GetCompanyData();
        }
      );
    } else {
      this.commonMethods.markFormGroupTouched(this.companyInfoForm);
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.$elementRef.nativeElement);
      });
    }
  }

  public CancelSaveInfo() {
    this.DestroySubscriptions();
    this.markFormsAsPristine();
    this.isEditMode = false;
    this.ChangeImageUploadMode(ImageUploadMode.View);
    customJS.resetPage(this.$elementRef.nativeElement);
    this.GetCompanyData();
    this.resetUnsavedTrigger.emit({ isUnsavedTriggered: false });
  }

  public CreateCompanyInfoForm(model: CompanyModel) {
    let licenses = this.GetStringArr(model.CompanyInfo.LicenseNumber, 3, "|");

    this.woWarranty.setValue((CommonMethods.CheckNullOrUndefined(model.Warranty)? "":model.Warranty.Content));
    this.saWarranty.setValue((CommonMethods.CheckNullOrUndefined(model.ServiceAgreementTermsAndCondition)? "":model.ServiceAgreementTermsAndCondition.Content));
    this.estWarranty.setValue((CommonMethods.CheckNullOrUndefined(model.EstimateTermsAndCondition)? "":model.EstimateTermsAndCondition.Content));
    this.companyInfoForm = new FormGroup({
      ID: new FormControl(model.ID),
      Name: new FormControl(model.Name, [Validators.required, Validators.maxLength(100)]),
      StreetNo: new FormControl(model.CompanyInfo.StreetAddress, [Validators.required, Validators.maxLength(100)]),
      Unit: new FormControl(model.CompanyInfo.Unit, Validators.maxLength(10)),
      City: new FormControl(model.CompanyInfo.City, [Validators.required, Validators.maxLength(50)]),
      State: new FormControl(model.CompanyInfo.State, Validators.required),
      ZipCode: new FormControl(model.CompanyInfo.ZipCode, [Validators.required, Validators.maxLength(15),this.ZipCodeValidator]),
      Phone: new FormControl(model.CompanyInfo.PhoneNumber, Validators.required),
      Email: new FormControl(model.CompanyInfo.EmailAddress, [this.EmailValidator,Validators.maxLength(100)]),
      Fax: new FormControl(model.CompanyInfo.FaxNumber),
      LogoURL: new FormControl(model.Logo),
      Website: new FormControl(model.CompanyInfo.SiteURL, [Validators.pattern(Constants.UrlRegex)]),
      Licence1: new FormControl(licenses[0], Validators.maxLength(50)),
      Licence2: new FormControl(licenses[1], Validators.maxLength(50)),
      Licence3: new FormControl(licenses[2], Validators.maxLength(50)),
      InvoiceFooter: new FormControl(model.CompanyInfo.InvoiceFooter),
      ServiceAgreementFooter: new FormControl(model.CompanyInfo.ServiceAgreementFooter),
      AccountingIntegration: new FormControl({ value: (this.auth.getCompanyQBType()), disabled: true }),
      EstimateFooter: new FormControl(model.CompanyInfo.EstimateFooter),

      PrintContentPreferenceList: new FormGroup({
        WO_ShowItemNo: new FormControl({value: this.CheckPrintSettings(PrintSettings.WorkOrder_ShowItemNumber,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        WO_ShowDispatchComment: new FormControl({value:this.CheckPrintSettings(PrintSettings.WorkOrder_ShowDispatchCommments,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        WO_ShowIssuesFound: new FormControl({ value: this.CheckPrintSettings(PrintSettings.WorkOrder_ShowIssueFound, model.PrintContentPreferenceList), disabled: !this.isEditMode }),
        WO_ShowAgreementSaving: new FormControl({ value: this.CheckPrintSettings(PrintSettings.WorkOrder_ShowAgreementSavings, model.PrintContentPreferenceList), disabled: !this.isEditMode }),

        Invoice_ShowItemNo: new FormControl({value:this.CheckPrintSettings(PrintSettings.Invoice_ShowItemNumber,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        Invoice_ShowDispatchComment: new FormControl({value:this.CheckPrintSettings(PrintSettings.Invoice_ShowDispatchComments,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        Invoice_ShowIssuesFound: new FormControl({value:this.CheckPrintSettings(PrintSettings.Invoice_ShowIssueFound,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        Invoice_ShowInvoiceComment: new FormControl({ value: this.CheckPrintSettings(PrintSettings.Invoice_ShowInvoiceComments, model.PrintContentPreferenceList), disabled: !this.isEditMode }),
        Invoice_ShowAgreementSaving: new FormControl({ value: this.CheckPrintSettings(PrintSettings.Invoice_ShowAgreementSavings, model.PrintContentPreferenceList), disabled: !this.isEditMode }),
      
        Estimate_ShowItemNo: new FormControl({value: this.CheckPrintSettings(PrintSettings.Estimate_ShowItemNumber,model.PrintContentPreferenceList),disabled:!this.isEditMode}),
        Estimate_ShowAgreementSaving: new FormControl({ value: this.CheckPrintSettings(PrintSettings.Estimate_ShowAgreementSavings, model.PrintContentPreferenceList), disabled: !this.isEditMode }),
        Estimate_ShowCustomerSignature: new FormControl({ value: this.CheckPrintSettings(PrintSettings.Estimate_ShowCustomerSignature, model.PrintContentPreferenceList), disabled: !this.isEditMode }),
      })
    });
    this.onChanges();
  }

  public DeleteImage(attachmentImageFileControl1, attachmentImageFileControl2) {
    this.ClearUploadControls(attachmentImageFileControl1, attachmentImageFileControl2);
    this.companyInfoForm.controls["LogoURL"].patchValue("");
    this.ChangeImageUploadMode(ImageUploadMode.Upload);
  }

  public ClearUploadControls(attachmentImageFileControl1, attachmentImageFileControl2) {
    $(attachmentImageFileControl1).val("");
    $(attachmentImageFileControl2).val("");
  }

  public ImageUploaded(selfRef,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview) {
    if (selfRef.target.files.length > 0) {
      this.ReadURL(event.target,
        DragAndDropImage,
        UploadImageBtn,
        ImagePreview,
        DeletePreview);
      this.companyInfoForm.controls["LogoURL"].patchValue("");
      this.ChangeImageUploadMode(ImageUploadMode.Edit);
    }
    else {
      this.ChangeImageUploadMode(ImageUploadMode.Upload);
    }
  }

  /** Change detection for terms&conditions, warranty */
  private onChanges() {
    this.subscriptions.push(this.woWarranty.valueChanges.subscribe(val => {
      this.companyInfoForm.markAsDirty();
    }));
    this.subscriptions.push(this.saWarranty.valueChanges.subscribe(val => {
      this.companyInfoForm.markAsDirty();
    }));
    this.subscriptions.push(this.estWarranty.valueChanges.subscribe(val => {
      this.companyInfoForm.markAsDirty();
    }));
  }

  private GetSubmitModel() {
    let model: CompanyModel = new CompanyModel();
    let companyInfo = this.companyData.CompanyInfo;
    let licenses = "";
    
    model.ID = this.companyData.ID
    model.ModifyDate = this.companyData.ModifyDate;
    model.Name = this.companyInfoForm.controls['Name'].value;
    model.Logo = this.companyInfoForm.controls['LogoURL'].value;
    companyInfo.EmailAddress = this.companyInfoForm.controls['Email'].value;
    companyInfo.FaxNumber = this.companyInfoForm.controls['Fax'].value;
    companyInfo.PhoneNumber = this.companyInfoForm.controls['Phone'].value;
    companyInfo.StreetAddress = this.companyInfoForm.controls['StreetNo'].value;
    companyInfo.Unit = this.companyInfoForm.controls['Unit'].value;
    companyInfo.City = this.companyInfoForm.controls['City'].value;
    companyInfo.State = this.companyInfoForm.controls['State'].value;
    companyInfo.ZipCode = this.companyInfoForm.controls['ZipCode'].value;
    companyInfo.SiteURL = this.companyInfoForm.controls['Website'].value;
    companyInfo.InvoiceFooter = this.companyInfoForm.controls['InvoiceFooter'].value;
    companyInfo.ServiceAgreementFooter = this.companyInfoForm.controls['ServiceAgreementFooter'].value;
    companyInfo.EstimateFooter = this.companyInfoForm.controls['EstimateFooter'].value;
    //#region Licenses
    let licenceArr = [];
    licenceArr.push(this.companyInfoForm.controls['Licence1'].value.trim())
    licenceArr.push(this.companyInfoForm.controls['Licence2'].value.trim())
    licenceArr.push(this.companyInfoForm.controls['Licence3'].value.trim())
    licenceArr.forEach(value => {
      if (value.length > 0) {
        licenses = licenses.concat(value, "|");
      }
    });
    licenses = licenses.length > 0 ? licenses.substring(0, licenses.length - 1) : licenses;
    //#endregion
    companyInfo.LicenseNumber = licenses;
    model.CompanyInfo = companyInfo;

    const PrintContentPreferenceList : string[] = this.FillPrintSettingsintoModel();

    model.PrintContentPreferenceList= PrintContentPreferenceList;
    model.Warranty = new TextEditorModel();
    model.Warranty.ID = CommonMethods.CheckNullOrUndefined(this.companyData.Warranty)? CommonMethods.GetID() 
                                                          : this.companyData.Warranty.ID;
    model.Warranty.SetContent(this.woWarranty.value);
    model.ServiceAgreementTermsAndCondition = new TextEditorModel();
    model.ServiceAgreementTermsAndCondition.ID = CommonMethods.CheckNullOrUndefined(this.companyData.ServiceAgreementTermsAndCondition)? CommonMethods.GetID() 
                                                          : this.companyData.ServiceAgreementTermsAndCondition.ID;
    model.ServiceAgreementTermsAndCondition.SetContent(this.saWarranty.value);
    model.EstimateTermsAndCondition = new TextEditorModel();
    model.EstimateTermsAndCondition.ID = CommonMethods.CheckNullOrUndefined(this.companyData.EstimateTermsAndCondition)? CommonMethods.GetID() 
                                          : this.companyData.EstimateTermsAndCondition.ID;
    model.EstimateTermsAndCondition.SetContent(this.estWarranty.value);

    return model;
  }

  private CheckPrintSettings(printSetting : string, modelData : string[])
  {
    if (!CommonMethods.CheckNullOrUndefined(modelData))
      return modelData.includes(printSetting);
    else return false;
  }

  private FillPrintSettingsintoModel() : string[]
  {
    let PrintContentPreferenceList: string[]=[];
    if(this.companyInfoForm.get('PrintContentPreferenceList.WO_ShowItemNo').value) PrintContentPreferenceList.push(PrintSettings.WorkOrder_ShowItemNumber);
    if(this.companyInfoForm.get('PrintContentPreferenceList.WO_ShowDispatchComment').value) PrintContentPreferenceList.push(PrintSettings.WorkOrder_ShowDispatchCommments);
    if (this.companyInfoForm.get('PrintContentPreferenceList.WO_ShowIssuesFound').value) PrintContentPreferenceList.push(PrintSettings.WorkOrder_ShowIssueFound);
    if (this.companyInfoForm.get('PrintContentPreferenceList.WO_ShowAgreementSaving').value) PrintContentPreferenceList.push(PrintSettings.WorkOrder_ShowAgreementSavings);
    if(this.companyInfoForm.get('PrintContentPreferenceList.Invoice_ShowItemNo').value) PrintContentPreferenceList.push(PrintSettings.Invoice_ShowItemNumber);
    if(this.companyInfoForm.get('PrintContentPreferenceList.Invoice_ShowDispatchComment').value) PrintContentPreferenceList.push(PrintSettings.Invoice_ShowDispatchComments);
    if(this.companyInfoForm.get('PrintContentPreferenceList.Invoice_ShowIssuesFound').value) PrintContentPreferenceList.push(PrintSettings.Invoice_ShowIssueFound);
    if (this.companyInfoForm.get('PrintContentPreferenceList.Invoice_ShowInvoiceComment').value) PrintContentPreferenceList.push(PrintSettings.Invoice_ShowInvoiceComments);
    if (this.companyInfoForm.get('PrintContentPreferenceList.Invoice_ShowAgreementSaving').value) PrintContentPreferenceList.push(PrintSettings.Invoice_ShowAgreementSavings);
    if(this.companyInfoForm.get('PrintContentPreferenceList.Estimate_ShowItemNo').value) PrintContentPreferenceList.push(PrintSettings.Estimate_ShowItemNumber);
    if (this.companyInfoForm.get('PrintContentPreferenceList.Estimate_ShowAgreementSaving').value) PrintContentPreferenceList.push(PrintSettings.Estimate_ShowAgreementSavings);
    if (this.companyInfoForm.get('PrintContentPreferenceList.Estimate_ShowCustomerSignature').value) PrintContentPreferenceList.push(PrintSettings.Estimate_ShowCustomerSignature);
    return PrintContentPreferenceList;
  }
  /**
   * Returns string array with default items if items are less that default count
   * @param value string to split
   * @param defeaulItemCount default items to return
   * @param delimiter 
   */
  private GetStringArr(value: string, defeaulItemCount: number, delimiter: string) {
    let licenceArr = [];
    if (!CommonMethods.CheckNullOrUndefined(value))
      licenceArr = value.split(delimiter);
    for (var i = 0; i < defeaulItemCount; i++) {
      if (licenceArr.length == i) {
        licenceArr.push("");
      }
    }
    return licenceArr;
  }

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }

  private ReadURL(input,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview) {
    let exts = this.uploadRestrictions.allowedExtensions;
    if (input.files && input.files[0]) {
      this.commonMethods
      if (!this.ValidateInputExt(input, this.uploadRestrictions.allowedExtensions)) {
        this.toastr.error(
          "Sorry, uploaded file is invalid, allowed extensions are: " +
          exts.join(", "),
          "Error"
        );
        $(input).val("");
        return;
      }
      if (input.files[0].size > this.uploadRestrictions.maxFileSize)
      {
        this.toastr.error("Sorry, File size is too large. Maximum file size permitted is 4 MB", "Error");
        $(input).val("");
        return;
      }
      this.showspinner.showloader(this.viewContainerRef, this.subTabCounter, 0);
      let postData = new FormData();
      postData.append("files", input.files[0]);
      this.httpCompany.UploadCompanyLogo(postData).subscribe(
        response => {
          this.companyInfoForm.controls['LogoURL'].patchValue(
            response[0].StorageLocation
          );
          
          $(this.attachImagePreview.nativeElement).show();
          $(this.attachmentDragAndDropImage.nativeElement).hide();
          this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
        },
        error => {
          this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
          this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    }
  }

  private ValidateInputExt(input, exts) {
    var fileName = input.value.toLowerCase();
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName
    );
  }

  private GetPlaceAutoComplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, {
      componentRestrictions: { country: this.mnemonicData? this.mnemonicData.mapCodes: 'US' },
      types: ["geocode"]
    });
    var me = this;
    this.addresstext.nativeElement.addEventListener("focus", function () {
      me.SetPosition()
    })
    this.addresstext.nativeElement.addEventListener("keyup", function () {
      me.SetPosition()
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let streetNumber = "";
      var isLocality: boolean = false;
      var isSubLocality: boolean = false;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (this.componentForm[addressType]) {
          var val = place.address_components[i][this.componentForm[addressType]];
          if (addressType == "locality") {
            this.companyInfoForm.get("City").setValue(val);
            isLocality = true;
          }
          if (addressType == "sublocality_level_1") {
            if (!isLocality) {
              this.companyInfoForm.get("City").setValue(val);
              isSubLocality = true
            }
          }
          if (addressType == "neighborhood") {
            if (!isLocality && !isSubLocality)
              this.companyInfoForm.get("City").setValue(val);
          }
          if (addressType == "postal_code")
            this.companyInfoForm.get("ZipCode").setValue(val);
          if (addressType == "street_number")
            streetNumber = val + " ";
          if (addressType == "route")
            this.companyInfoForm.get("StreetNo").setValue(streetNumber + val);
          if (addressType == "administrative_area_level_1")
            this.companyInfoForm.get("State").setValue(val);
        }
      }
    })
  }
  private SetPosition() {
    var self = this;
    let topOffset = $(self.addresstext.nativeElement).offset().top;
    setTimeout(function () {
      var boxHeight = 0;
      if (self.addresstext.nativeElement.value.length == 1) {
        boxHeight = 177;
      }
      else {
        boxHeight = $('.pac-container').last().outerHeight();
      }

      let windowHeight = window.innerHeight;
      if (topOffset + (boxHeight + 50) > windowHeight) {
        $('.pac-container').addClass("showUp").css('margin-top', -(boxHeight + 35) + 'px')
      }
      else {
        $('.pac-container').removeClass("showUp").css('margin-top', '0')
      }
    }, 10)
  }
  private markFormsAsPristine() {
    this.companyInfoForm.markAsPristine();
    this.woWarranty.markAsPristine();
    this.saWarranty.markAsPristine();
    this.estWarranty.markAsPristine();
  }
  //#endregion
}